import $ from 'jquery'

window.jQuery = window.$ = $
import('./slick')
import('./common')
